import Badge from '@polyai/ui/components/atoms/Badge';
import {
  ConditionVerticalIcon,
  StepIcon,
  WandIcon,
} from '@polyai/ui/components/atoms/Icons';

import useFeatureSwitch from 'hooks/useFeatureSwitch/useFeatureSwitch';

export type IconBadgeType = 'default_step' | 'advanced_step' | 'function_step';

interface IconBadgeProps {
  type: IconBadgeType;
  className?: string;
  size?: 'md' | 'sm' | 'xs';
}

export const IconBadge = ({ type, className, size = 'md' }: IconBadgeProps) => {
  const { isFeatureOn } = useFeatureSwitch();

  const badgeConfig = {
    default_step: {
      Icon: StepIcon,
      variant: 'blue' as const,
      shape: undefined as 'hexagon' | undefined,
    },
    advanced_step: {
      Icon: isFeatureOn('no_code_flow') ? WandIcon : StepIcon,
      variant: 'green' as const,
      shape: undefined as 'hexagon' | undefined,
    },
    function_step: {
      Icon: ConditionVerticalIcon,
      variant: 'yellow' as const,
      shape: 'hexagon' as const,
    },
  };

  const config = badgeConfig[type];

  return (
    <Badge
      Icon={config.Icon}
      className={className}
      data-test-id="step-icon-badge"
      shape={config.shape}
      size={size}
      variant={config.variant}
      inverse
    />
  );
};
